export const accordionDataCanales = [
  {
    title: '¿Los canales premium están incluidos en los planes?',
    content: `Absolutamente. Vas a poder disfrutar de toda la programación de Discovery +, HBO Max y Golden, con cualquiera de nuestros planes.`
  },
  {
    title: '¿Otra pregunta sobre Canales?',
    content: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Mollitia veniam
    reprehenderit nam assumenda voluptatem ut. Ipsum eius dicta, officiis
    quaerat iure quos dolorum accusantium ducimus in illum vero commodi
    pariatur? Impedit autem esse nostrum quasi, fugiat a aut error cumque
    quidem maiores doloremque est numquam praesentium eos voluptatem amet!
    Repudiandae, mollitia id reprehenderit a ab odit!`
  }
];